import React from "react";
import { EditAction } from "components/buttons";
import { Restricted, permissions } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import { useMutation } from "@apollo/react-hooks";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";

const ActionButtons = ({ id, asset, currentCustomerId, mutation, history, intl }) => {
  const [deleteAsset] = useMutation(mutation);

  const commonAsset = asset ? !asset.customerId : false;
  const name = asset ? asset.codename : "";
  const hasGraphicsets = asset && asset.hasGraphicsets;

  return !asset ? null : (
    <>
      <Restricted permissions={[commonAsset ? permissions.asset_common_manage : permissions.asset_manage]}>
        <EditAction url={`/asset/edit/${id}`} />
        <DeleteActionWithModal
          disabledTooltipText={intl.formatMessage({ id: "app.asset.delete.hasGraphicsets" })}
          disabled={hasGraphicsets}
          actionButton
          urlOnSuccess="/asset/list"
          history={history}
          mutation={deleteAsset}
          mutationVariables={{ assetId: id, customerId: currentCustomerId }}
          elementNameInResult="deleteAsset"
          elementToDelete={name}
        />
      </Restricted>
    </>
  );
};

ActionButtons.propTypes = {
  /**
   * Id del elemento sobre el que se realiza la acción
   **/
  id: PropTypes.string,
  /**
   * Id del customer actual
   **/
  currentCustomerId: PropTypes.string,
  /**
   * Asset a representar
   **/
  asset: PropTypes.object,
  /**
   * Query gql de borrado del elemento
   **/
  mutation: PropTypes.object,
};

export default injectIntl(ActionButtons);
